import React from 'react';
import VisitPaymentDetails from './Components/VisitPaymentDetails';

const PaymentDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <VisitPaymentDetails />
      </div>
    </div>
  );
};

export default PaymentDetailsPage;
